import { gql } from "@apollo/client";

export const CONFIRM_EMAIL = gql`
  mutation confirmEmail($magicData: String, $confirmationCode: String) {
    confirmEmail(input: { magicData: $magicData, confirmationCode: $confirmationCode })
  }
`;
